import { render, staticRenderFns } from "./RegionSelect.vue?vue&type=template&id=4c922162&scoped=true&lang=html&"
import script from "./RegionSelect.vue?vue&type=script&lang=js&"
export * from "./RegionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c922162",
  null
  
)

export default component.exports